import React from 'react';

import clsx from 'clsx';

import * as classes from './NoConversion.module.css';

const NoConversion = ({
    ...props
}) => {

    return (
        <div className={classes.NoConversion}>
            <span className={clsx('material-icons-outlined md-18', classes.Icon)}>
                info
            </span>
            <span className={classes.Text}>Select a 'Conversion' to view the builder details</span>
        </div>
    );
};

export default NoConversion;
